exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ocult-form {\n  display: none;\n}\n", ""]);

// exports
